import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const useBenbefitCodeList = (orderId: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  const { set: setError } = useApiError();
  // console.log("usePaymethodcontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `useBenbefitCodeList-${orderId}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `useBenbefitCodeList-loading-${orderId}`);

  // Shared ref holding errors from the methods
  const error = sharedRef(null, `useBenbefitCodeList-error-${orderId}`);

  // 使用折扣码
  const getCodelist = async (customQuery) => {
    try {
      loading.value = true;
      // console.log('折扣码参数---------', customQuery);
      const res = await context.$xbuy.api.memberBenefitCodeList(customQuery);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        result.value = res?.data?.data;
        error.value = null;
      } else {
        setError({ message: res.message, code: res.code });
        result.value = null;
        error.value = res.message;
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  return {
    getCodelist: getCodelist,
    list: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
